import request from "@/utils/request"

/****************
 *    Competitor prices
 ****************/
export function getCompetitorPrices(params) {
  return request({
    url: "/api/prix",
    method: "get",
    params
  })
}

/**
 *
 * @param {Number} id - price id to delete
 */
export function getCompetitorPrice(id) {
  return request({
    url: "/api/prix/" + id,
    method: "get"
  })
}

/**
 *
 * @param {Object} params - request params
 * @param {Object} data - request data
 */
export function createCompetitorPrice(data, params = {}) {
  return request({
    url: "/api/prix",
    method: "post",
    params,
    data
  })
}

/**
 *
 * @param {Object} params - request params
 * @param {Object} data - request data
 */
export function createManyCompetitorPrice(data, params = {}) {
  return request({
    url: "/api/prix/add/many",
    method: "post",
    params,
    data
  })
}

/**
 *
 * @param {Object} params - request params
 * @param {Object} data - request data
 */
export function updateCompetitorPrice(id, data, params = {}) {
  return request({
    url: "/api/prix/" + id,
    method: "put",
    params,
    data
  })
}

/**
 *
 * @param {Number} id - price id to delete
 */
export function deleteCompetitorPrice(id) {
  return request({
    url: "/api/prix/" + id,
    method: "delete"
  })
}

/**
 *
 * @param {Object} params - request params
 * @param {Object} data - request params
 */
export function importCompetitorPrice(params, data) {
  return request({
    url: "/api/prix/import",
    method: "post",
    params,
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

/**
 *
 * @param {Object} params - request params { video_ean }
 * @param {Object} data - request params
 */
export function getVideoCompetPrices(params) {
  return request({
    url: `/api/prix/video/${params}`,
    method: "get",
    params
  })
}
